import Highcharts from "highcharts";
import { chartConfig } from "../chart.commonConfig";

import { PDF_CONSTANT } from "../../../../constant";
import { chartsLoadedAction } from "../../../../actions/reports.action";

export const ISSUE_MONITORED_CHART_DASHBOARD_HELPER = data => {
  const BAR_CHART_CONFIG = {
    chart: {
      ...chartConfig.chart,
      zoomType: "xy",
      renderTo: "bar-chart",
      className: "chart-background",
      spacingBottom: 15,
      spacingRight: 35,
      animation: {
        duration: 9000
      },
      events: {
        load: () => {
          chartsLoadedAction({
            type: PDF_CONSTANT.FIRST_PAGE.SECOND._SUCCESS
          });
        }
      }
    },
    title: {
      ...chartConfig.title,
      text: ""
    },
    xAxis: [
      {
        categories: [],
        className: "bar-label",
        labels: {
          autoRotation: [-90],
          style: {
            "font-weight": "300"
          },
          formatter: function() {
            return this.value;
          }
        }
      }
    ],
    yAxis: [
      {
        // Primary yAxis
        labels: {
          //  format: `{value}`,
          style: {
            "font-weight": "300"
          }
        },
        title: {
          text: "Number of Issue(s)",
          style: {
            color: "black"
          }
        },
        min: 0,
        max: 1000,
        tickAmount: 6,
        className: "bar-label"
      }
    ],
    tooltip: {
      shared: true,
      formatter: function() {
        const { points } = this;
        return `
                <b>${this.x}</b><br />
                <b>Issues: ${this.y}</b>
              `;
      }
    },
    legend: {
      verticalAlign: "bottom",
      layout: "horizontal",
      align: "center",
      symbolRadius: 0,
      itemStyle: {
        color: "black"
      },
      backgroundColor:
        Highcharts.defaultOptions.legend.backgroundColor || // theme
        "rgba(255,255,255,0.25)"
    },
    series: [
      {
        name: "PMG Monitored Issue(s)",
        type: "spline",
        yAxis: 0,
        zIndex: 1,
        data: [],
        dataLabels: {
          allowOverlap: true,
          enabled: true,
          style: {
            textOutline: "none"
          }
        },
        color: "#3782DE"
      }
    ],
    plotOptions: {
      series: {
        animation: true,
        marker: {
          fillColor: "#E86234",
          lineWidth: 1,
          lineColor: "#E86234"
        },
        events: {
          legendItemClick: function(event) {
            event.preventDefault();
          }
        }
      }
    }
  };

  // extract data for charts
  const extractData = { year: [], totalIssues: [] };
  data.forEach(({ year, totalIssues }) => {
    extractData.year.push(year);
    extractData.totalIssues.push(totalIssues);
  });
  // set data
  BAR_CHART_CONFIG.xAxis[0].categories = extractData.year;
  BAR_CHART_CONFIG.series[0].data = extractData.totalIssues;
  BAR_CHART_CONFIG.yAxis[0].max = Math.max(...extractData.totalIssues) + 500;

  return BAR_CHART_CONFIG;
};
